import { render, staticRenderFns } from "./notificationModal.vue?vue&type=template&id=32129659"
import script from "./notificationModal.vue?vue&type=script&lang=js"
export * from "./notificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Toggle: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Toggle.vue').default,NotificationsItem: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/notifications/item.vue').default,Pagination: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Pagination.vue').default})
